import axios, { AxiosInstance } from 'axios'

import { handleDates } from './interceptorHandlers'

const apiClient = (): AxiosInstance => {
  const instance = axios.create({
    // baseURL: process.env.NEXT_PUBLIC_WEBSITE_URL,
    proxy: undefined,
    withCredentials: true,
    paramsSerializer: function (params) {
      return new URLSearchParams(params).toString()
    },
  })

  instance.interceptors.response.use((originalResponse) => {
    handleDates(originalResponse.data)
    return originalResponse
  })

  return instance
}

export default apiClient()
